class Item {

	constructor(__element) {

		this.checkPosition = this.checkPosition.bind(this);

		this.$item = __element;
		this.$imageContainer = this.$item.find('.CategoryCover__Image');
		this.$image = this.$imageContainer.find('img');
		this.position = $(window).height();
		this.active = false;
		this.size = {
			width: 0,
			height: 0
		};

	}

	savePosition() {

		this.position = this.$item.offset().top;
		this.$imageContainer.removeClass('CategoryCover__Image-abs');

		this.size = {
			width: this.$image.width(),
			height: this.$image.height()
		};

		this.$imageContainer.css({
			'width': `${this.size.width}px`,
			'height': `${this.size.height}px`
		})

		this.$imageContainer.addClass('CategoryCover__Image-abs');

		if (!this.active) {
			this.$image.css('clip',`rect(0px, 0px, ${this.size.height}px, 0px)`);
		} else {
			this.$image.css('clip',`rect(0px, ${this.size.width}px, ${this.size.height}px, 0px)`);
		}

	}

	checkPosition(__scrollTop = 0) {

		if (__scrollTop >= this.position && !this.active) {

			this.$image.css('clip',`rect(0px, ${this.size.width}px, ${this.size.height}px, 0px)`);
			this.active = true;

		}

	}

}

class CategoryCover {

	constructor() {

		this.resizeHandler = this.resizeHandler.bind(this);
		this.checkView = this.checkView.bind(this);

		this.items = [];
		this.$items = $('.CategoryCover');
		this.$items.each((index, item) => {

			const instance = new Item($(item));
			this.items.push(instance);

		});

		$(window).on('load', this.resizeHandler);
		$(window).on('resize', this.resizeHandler);
		$(window).on('scroll', this.checkView);

	}

	resizeHandler() {

		this.items.forEach(item => {
			item.savePosition();
			item.checkPosition($(window).height());
		})

	}

	checkView() {

		const scrollTop = $(window).scrollTop() + $(window).height() * 0.8;

		this.items.forEach((item, index) => {
			item.checkPosition(scrollTop);
		});

	}

}

export default new CategoryCover();



// WEBPACK FOOTER //
// ./js/components/categoryCover.js